export const getApiHeaders = (contentType: 'json' | 'form-data' | 'none' = 'json'): HeadersInit => {
  const token = localStorage.getItem('token');
  const crmToken = process.env.REACT_APP_CRM_TOKEN || '';
  
  const headers: HeadersInit = {
    'Authorization': `Bearer ${token}`,
    'x-crm-token': crmToken,
  };

  if (contentType === 'json') {
    headers['Content-Type'] = 'application/json';
  }

  return headers;
};
